/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

export default {
  name: 'Toast',
  props: {
    iconLeft: {
      type: String,
      default: null
    },
    iconRight: {
      type: String,
      default: null
    },
    static: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    },
    timeout: {
      type: Number,
      default: 10000
    }
  },
  data () {
    return {
      isShowing: true,
      timeoutRef: null
    };
  },
  created () {
    if (!this.static) {
      this.startTimer();
    }
  },
  methods: {
    hideToast () {
      this.isShowing = true;
      this.$emit('onHide');
      clearTimeout(this.timeoutRef);
    },
    showToast () {
      this.isShowing = true;
      this.$emit('onShown');
      if (!this.static) {
        this.startTimer();
      }
    },
    startTimer () {
      const self = this;
      this.timeoutRef = setTimeout(() => {
        self.hideToast();
      }, this.timeout);
    }
  }
};
